import { Images } from 'assets/images';

export const OFFER_DATA = [];

export const TemplateOptions = [
  {
    title: 'Yerevan, Armenia',
    id: '1',
    description:
      'lorem lorem lorem lorem lorem lorem lorem lorem lorem ' +
      'lorem lorem lorem lorem lorem lorem lorem lorem lorem ' +
      'lorem lorem lorem lorem lorem lorem lorem lorem lorem' +
      ' loremlorem lorem lorem lorem lorem lorem lorem',
    image: Images.bali,
    country_city: 'United States, New York',
    stay: '02/10/2022 - 17/10/2022',
    population: '18,8 million',
    language: 'English',
    booking_url: 'https//www.booking.com/',
    ticket_url: 'https//www.ticket.com/',
    price: '750 $',
  },
  {
    title: 'Stand Up, Armenia',
    id: '2',
    description: 'lorem lorem lorem lorem lorem lorem lorem',
    image: Images.CountDownBackground2,
    country_city: 'United States, New York',
    stay: '02/10/2022 - 17/10/2022',
    population: '18,8 million',
    language: 'English',
    booking_url: 'https//www.booking.com/',
    ticket_url: 'https//www.ticket.com/',
    price: '450 $',
  },
  {
    title: 'Gago, Armenia',
    id: '5',
    description: 'lorem lorem lorem lorem lorem lorem lorem',
    image: Images.CountDownBackground4,
    country_city: 'United States, New York',
    stay: '02/10/2022 - 17/10/2022',
    population: '18,8 million',
    language: 'English',
    booking_url: 'https//www.booking.com/',
    ticket_url: 'https//www.ticket.com/',
    price: '250 $',
  },
];
